import { DELETE_MOTORCYCLE_ERROR } from "Constant";
import {
  MANAGE_LEADS_ALL_START,
  MANAGE_LEADS_ALL_SUCCESS,
  MANAGE_LEADS_ALL_ERROR,
  GET_LEAD_BY_ID_START,
  GET_LEAD_BY_ID_SUCCESS,
  GET_LEAD_BY_ID_ERROR,
  DELETE_LEAD_BY_ID_START,
  DELETE_LEAD_BY_ID_SUCCESS,
  DELETE_LEAD_BY_ID_ERROR,
  FETCH_TOUR_LEAD_LANGAUAGE_START,
  FETCH_TOUR_LEAD_LANGAUAGE_SUCCESS,
  FETCH_TOUR_LEAD_LANGAUAGE_ERROR,
} from "../Constant/manageLeadsConstant";

const initialState = {
  loading: false,
  allLeads: [],
  leadById: [],
  deletelead: [],
  leadLanguages: [],
};

export default function ManageLeadsreducer(
  state = { ...initialState },
  action
) {
  switch (action.type) {
    case MANAGE_LEADS_ALL_START:
      return {
        ...state,
        loading: true,
      };
    case MANAGE_LEADS_ALL_SUCCESS:
      return {
        ...state,
        allLeads: action.payload,
        loading: false,
      };
    case MANAGE_LEADS_ALL_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };
    case GET_LEAD_BY_ID_START:
      return {
        ...state,
        loading: true,
      };
    case GET_LEAD_BY_ID_SUCCESS:
      return {
        ...state,
        leadById: action.payload,
        loading: false,
      };
    case GET_LEAD_BY_ID_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };
    case DELETE_LEAD_BY_ID_START:
      return {
        ...state,
        loading: true,
      };
    case DELETE_LEAD_BY_ID_SUCCESS:
      return {
        ...state,
        deletelead: action.payload,
        loading: false,
      };
    case DELETE_MOTORCYCLE_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };
    case FETCH_TOUR_LEAD_LANGAUAGE_START:
      return {
        ...state,
        loading: true,
      };
    case FETCH_TOUR_LEAD_LANGAUAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        leadLanguages: action.payload?.tourLeadLanguage,
      };
    case FETCH_TOUR_LEAD_LANGAUAGE_ERROR:
      return {
        ...state,
        loading: false,
        leadLanguages: [],
      };
    default:
      return state;
  }
}
